function initProductTabs(scope){

  const wrappers = (scope || document).querySelectorAll(".pht-wrapper");

  wrappers.forEach(wrapper => {

    const tabs = wrapper.querySelectorAll(".pht-tab");
    const panels = wrapper.querySelectorAll(".pht-panel");

    tabs.forEach(tab => {
      tab.addEventListener("click", function(){

        const id = this.dataset.tab;

        tabs.forEach(t => t.classList.remove("active"));
        panels.forEach(p => p.classList.remove("active"));

        this.classList.add("active");
        wrapper.querySelector("#" + id).classList.add("active");

      });
    });

  });
}

/* página carregada normalmente */
document.addEventListener("DOMContentLoaded", function(){
  initProductTabs(document);
});

/* quando a section é carregada dentro do editor da Shopify */
document.addEventListener("shopify:section:load", function(e){
  initProductTabs(e.target);
});
